import React, { useState, useEffect } from 'react'
import CustomDisputeRiskTable from '../../Common/ui/riskTable'
import { useRiskStore } from './Store/RiskStore'
import Loading from '../../Common/ui/Loading'
import '../../Styles/RiskContainer.css'
import InitiationSelect from 'src/Common/Icon/InitiationSelect'
import ApprovalSelect from 'src/Common/Icon/ApprovalSelect'
import AnalyseSelect from 'src/Common/Icon/AnalyseSelect'
import MonitoringSelect from 'src/Common/Icon/MonitoringSelect'

const RiskHistory = () => {
    const { riskDetailsLoading, getNonComplianceLoading, clearHistoryFilter } = useRiskStore()
    const [ activeTab, setActiveTab ] = useState('1')
    const getRiskHistoryFilterData = useRiskStore(state => state.getRiskHistoryFilterData)
    const historyFilterPayload = useRiskStore(state => state.historyFilterPayload)
    const [ data, setData ] = useState([])
    // const queryParams = new URLSearchParams(location.search)

    // const type = queryParams.get('type')
    useEffect(() => {
        clearHistoryFilter()
    }, [location])
    useEffect(() => {
        setData(getRiskHistoryFilterData)
    }, [getRiskHistoryFilterData])
    const handleTabChange = (newTab) => {
        setActiveTab(newTab)
    }

    const tableHeaders = [
        { field: 'risk', headerName: 'Risk' },
        { field: 'description', headerName: 'Description' },
        { field: 'status', headerName: 'Status' },
        { field: 'aging', headerName: 'Age' },
        { field: 'approach', headerName: 'Approach' },
        { field: 'riskNature', headerName: 'Risk Nature' },
        { field: 'category', headerName: 'Category' },
        { field: 'riskOwner', headerName: 'Risk Owner' },
        { field: 'impactedDepartment', headerName: 'Impacted Department' },
        { field: 'dot', headerName: '' }
    ]
    // eslint-disable-next-line no-unused-vars
    const [ headerTabs, setHeaderTabs ] = useState([
        {
            id: 1,
            name: 'Acceptance',
            count: 0,
            selected: true,
            defImg: <InitiationSelect isActive={true} />,
            selImg: <InitiationSelect isActive={false} />,
            show: true
        },
        {
            id: 2,
            name: 'Avoidance',
            count: 0,
            selected: true,
            defImg: <ApprovalSelect isActive={true} />,
            selImg: <ApprovalSelect isActive={false} />,
            show: true
        },
        {
            id: 3,
            name: 'Reduction',
            count: 0,
            selected: true,
            defImg: <AnalyseSelect isActive={true} />,
            selImg: <AnalyseSelect isActive={false} />,
            show: true
        },
        {
            id: 4,
            name: 'Transfer',
            count: 0,
            selected: true,
            defImg: <MonitoringSelect isActive={true} />,
            selImg: <MonitoringSelect isActive={false} />,
            show: true
        }
    ])
    // const tableHeadersNonCompliance = [
    //     { field: 'risk', headerName: 'Risk' },
    //     { field: 'description', headerName: 'Description' },
    //     { field: 'accountable', headerName: 'Accountable' },
    //     { field: 'responsible', headerName: 'Responsible' },
    //     { field: 'consulted', headerName: 'Consulted' },
    //     { field: 'informed', headerName: 'Informed' },
    //     { field: 'dot', headerName: '' }
    // ]

    // useEffect(() => {
    //     setHeaderTabs((prevState) => {
    //         return prevState.map(ele => {
    //             let data = {}
    //             data = ele

    //             if (+type === +data.id) {
    //                 setData(getRiskHistoryFilterData.filter(ele => ele.approach === +type))

    //                 data = { ...data, selected: true }
    //             } else {
    //                 data = { ...data, selected: false }
    //             }
    //             return data
    //         })
    //     })
    // }, [location.search])
    const [ text, setText ] = useState('')
    useEffect(() => {
        if (Object.keys(historyFilterPayload)?.length > 0) {
            setText('No Records Found')
        } else {
            setText('Kindly Apply Filters')
        }
    }, [historyFilterPayload])
    const getTableHeadersAndData = () => {
        return { headers: tableHeaders, data }
        // ? { headers: tableHeaders, data }
        // : { headers: tableHeadersNonCompliance, data: getNonComplianceData }
    }
    // const navigate = useNavigate()

    // const handleSelect = (menu, name) => {
    //     queryParams.set('type', menu)
    //     navigate(`?${queryParams.toString()}`)
    //     // navigate(MAIN_CONTAINER.MAIN + ISSUE.URI + `?${name}`)
    // }
    return (
        <div className='h-[100%] p-6'>
            <Loading isLoading={riskDetailsLoading || getNonComplianceLoading} />
            {/* <Grid container gap={0} direction="row" justifyContent="space-between" className='h-[20%] px-5 w-[100%] items-center' >
                {
                    headerTabs?.map((item, i) => {
                        return (
                            <>
                                {<Grid item xs={2.5} sm={2.5} md={2.5}>
                                    <div
                                        className={`heatmap-card ${item.selected ? 'selectedCard' : ''}`}
                                        onClick={() => handleSelect(item.id, item?.name)}
                                    >
                                        <Card className='p-5 border-2 heatmap-card-content flex' style={{
                                            border: item.selected ? '2px solid hsl(var(--primary))' : '2px solid hsl(var(--card))',
                                            background: item.selected ? 'hsl(var(--primary-foreground))' : 'hsl(var(--card))'
                                        }}>
                                            <div aria-label="" role="img" className="flex-shrink-0 flex justify-center items-center risk-avatar m-2" style={{
                                                backgroundColor: item.selected ? 'hsl(var(--primary))' : 'hsl(var(--primary-foreground))'
                                            }}>

                                                <div className='ml-2 mt-2'>{!item.selected ? item.selImg : item.defImg}</div>
                                            </div>
                                            <div className='flex flex-col justify-center pl-2'>
                                                <h3 className='font-bold text-muted'>{countFinder(item.id) || 0}</h3>
                                                <div className='text-h4 text-primary'>{item.name}</div>
                                            </div>
                                        </Card>
                                    </div>
                                </Grid>}
                            </>

                        )
                    })
                }
            </Grid> */}
            <div className='h-full'>
                <CustomDisputeRiskTable tabletext={text}tableHeaders={getTableHeadersAndData().headers} tableBodyData={getTableHeadersAndData().data} onTabChange={handleTabChange} activeTab={activeTab} key={activeTab} generalCount={0} nonComplianceCount={0} />
            </div>
        </div>
    )
}

export default RiskHistory
